import { useTranslation } from 'react-i18next';
import { BatchReturn } from 'returnCenter-api';
import { batchOptionLabel } from 'utils/batchRowMove';

type BatchReturnOptionsProps = {
    batches: BatchReturn[];
    currentBatchReturnId: number | null;
    moveMode: boolean;
};

/**
 * The batches a row can be put in. A sent row is moved, never taken out of batch handling, and its
 * current batch may no longer be open, so it is listed on its own.
 */
const BatchReturnOptions = ({ batches, currentBatchReturnId, moveMode }: BatchReturnOptionsProps) => {
    const { t } = useTranslation();
    const keptBatchId = moveMode ? currentBatchReturnId : null;

    return (
        <>
            {keptBatchId == null && <option value="">{t('batchReturn.notAssigned', '-- Not assigned --')}</option>}
            {keptBatchId != null && !batches.some((br) => br.id === keptBatchId) && (
                <option value={keptBatchId}>
                    {t('batchReturn.currentBatch', '#{{id}} (current)', { id: keptBatchId })}
                </option>
            )}
            {batches.map((br) => (
                <option key={br.id} value={br.id}>
                    {batchOptionLabel(br)}
                </option>
            ))}
        </>
    );
};

export default BatchReturnOptions;
